// Zentrale, wiederverwendbare Formular-Validierungen.
// Alle Funktionen geben einen boolean zurück; die Fehlertexte werden
// in den jeweiligen Formularen gesetzt (Inline-Fehler).

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isEmail(value) {
  return EMAIL_REGEX.test(String(value ?? "").trim());
}

export function isValidPassword(value, min = 8) {
  return String(value ?? "").length >= min;
}

export function passwordsMatch(a, b) {
  return String(a ?? "") === String(b ?? "") && String(a ?? "").length > 0;
}

// PLZ für CH/AT/DE: 4–5 Ziffern
export function isPlz(value) {
  return /^\d{4,5}$/.test(String(value ?? "").trim());
}

// Telefonnummer inkl. Ländervorwahl CH/AT/DE (z.B. +41791234567): 9–15 Ziffern
// (Whitespace/Sonderzeichen ignoriert)
export function isPhone(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  return /^(41|43|49)\d{7,13}$/.test(digits);
}

export function isRequired(value) {
  return String(value ?? "").trim().length > 0;
}

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_HINT = `Mindestens ${PASSWORD_MIN_LENGTH} Zeichen`;
